import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

const timeRegex = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/;

const reapproCategoryFormSchema = z.object({
    name: z.string().min(1).max(30),
    daysBefore: z.coerce.number().min(1).max(30),
    computeHour: z.string().regex(timeRegex, { message: 'Heure de calcul invalide' }),
    sendHour: z.string().regex(timeRegex, { message: "Heure d'envoi invalide" }),
    logHour: z.string().regex(timeRegex, { message: 'Heure de log invalide' }),
    productIds: z.array(z.number()).optional(),
});

export type ReapproCategoryForm = z.infer<typeof reapproCategoryFormSchema>;

// Form hook
export const useReapproCategoryForm = (defaultValues?: Partial<ReapproCategoryForm>) => {
    const form = useForm<ReapproCategoryForm>({
        resolver: zodResolver(reapproCategoryFormSchema),
        defaultValues: {
            ...defaultValues,
        },
    });

    return form;
};
